import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ClientService} from "../auth/client.service";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {IClientRetentionSettings} from "../../models/client-retention-settings.model";

@Injectable({
  providedIn: 'root'
})
export class ClientRetentionService {
  protected http = inject(HttpClient);
  protected clientService = inject(ClientService);

  protected api = '/clients/settings/';

  protected getEndpoint(): string {
    return environment.aiBaseServerUrl + this.clientService.client?.id + this.api;
  }

  getAsync(): Observable<IClientRetentionSettings> {
    return this.http.get<IClientRetentionSettings>(this.getEndpoint());
  }

  saveAsync(conversationRetentionDays: number | null, conversationCategories: string[]): Observable<IClientRetentionSettings> {
    return this.http.post<IClientRetentionSettings>(this.getEndpoint(), {
      clientId: this.clientService.client?.id ?? '',
      conversationRetentionDays,
      conversationCategories
    });
  }
}
